const ServicesHero = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c445151e30e57d87fd1f1bc6d78f8462.jpg"
          alt="Our Services"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <div className="inline-block bg-yellow-500 text-black px-4 py-2 rounded-full text-sm font-bold mb-6">
            OUR SERVICES
          </div>

          <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
            Professional Concrete & Stone Solutions
          </h1>

          <p className="text-xl text-gray-200 leading-relaxed">
            From residential projects to large-scale commercial developments, we provide comprehensive concrete pumping and stone installation services with precision and expertise.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;